/**
 * TrustGate Console - Card Component
 * Consistent card container for all console views
 */

import React from 'react';

interface CardProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
  error?: boolean;
  warning?: boolean;
}

export const Card: React.FC<CardProps> = ({ 
  title, 
  children, 
  className = '',
  error = false,
  warning = false 
}) => {
  const borderColor = error 
    ? 'border-red-500/50' 
    : warning 
    ? 'border-yellow-500/50' 
    : 'border-white/10';

  return (
    <div className={`bg-[#1a1a2e] border ${borderColor} rounded-xl p-6 ${className}`}>
      {title && (
        <h2 className="text-xl font-semibold text-[#f8fafc] mb-4">
          {title}
        </h2>
      )}
      {children}
    </div>
  );
};
